import {
  FAQS,
  AnalyticsHeader,
  REGISTRATION_CARDS,
  PRE_PURCHASE_FAQS,
  TERMS_AND_CONDITION,
  REGISTER_TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const logo =
  "https://ss-leagues.s3.amazonaws.com/MLS/Sounders/seattle-sounders-logo.png";
const landingPageStaticBannerUrl =
  "https://ss-leagues.s3.amazonaws.com/MLS/Sounders/Desktop%2020.26_Offer_1920x450.png";
const mobileLandingPageStaticBannerUrl =
  "https://ss-leagues.s3.amazonaws.com/MLS/Sounders/%2420.26_Offer_375x550%20Mobile.png";
const orderSummaryBackgroundUrl =
  "https://ss-leagues.s3.amazonaws.com/MLS/Sounders/Backround%20Image%2020.26_Offer_Images02_1920x1080.png";

export const seattlesounders_flow: TTeamConfig = {
  TEAM_SCHEMA: "seattlesounders_flow",
  TEAM_FULL_NAME: "Seattle Sounders FC",
  BROWSER_TITLE: "Sounders $20.26 Ticket Offer",
  CLIENT_ID: "c244269e0844.seasonshare.sixers-sixers.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#000000",
    COLORS_SECONDARY: "#0000FF",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    ANALYTICS_HEADER: AnalyticsHeader,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,

    FOOTER: {
      BACKGROUND_COLOR: "#0000FF",
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
    HIDE_PASSES: true,

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      SECTION_TITLE: <>Experience Seattle Soccer Culture.</>,
      IS_EXPANDED_CARD: true,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTER_TERMS_AND_CONDITION />,
      PHONE_INPUT_DESCRIPTION:
        "Receive ticketing and matchday related updates only.",
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
      NEXT_GAME_LABEL: "Next Match",
    },

    PAGE_TITLE: "$20.26 Offer Schedule",
    ALL_GAMES_BUTTON_LABEL: "Upcoming Matches",

    ADD_ON: {
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () =>
          "Your seats are guaranteed for the match. We will distribute your tickets and seating location 9am the day before the match. You will receive a text message when tickets are ready to be managed on matchday.",
      },
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },

    ADD_DARK_OVERLAY: true,
    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: logo,
    ORDER_SUMMERY_BACKGROUND_URL: orderSummaryBackgroundUrl,
    LANDING_PAGE_STATIC_BANNER_URL: landingPageStaticBannerUrl,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileLandingPageStaticBannerUrl,
  },

  LANGUAGES: {
    FAQS,
    PRE_PURCHASE_FAQS,
    TERMS_AND_CONDITION,
  },
};
